"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaPlaybackControls = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _video = _interopRequireDefault(require("video.js"));
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _SliderV = _interopRequireDefault(require("./SliderV2/SliderV2"));
var _MediaPlaybackController = require("./MediaPlaybackController.styled");
var _feature = require("@studio/feature.flags");
var _metrics = require("@studio/metrics");
var _constants = require("@studio/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var formatTime = function formatTime() {
  var secs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var hrs = ~~(secs / 3600);
  if (hrs > 0) {
    return (0, _moment["default"])().startOf('day').seconds(secs).format('H:mm:ss');
  }
  return (0, _moment["default"])().startOf('day').seconds(secs).format('mm:ss');
};
var RestartControlIcon = _react["default"].memo(function RestartControlIcon(props) {
  return _react["default"].createElement(_MediaPlaybackController.StyledControlIcon, props);
});
var DurationLabel = _react["default"].memo(function DurationLabel(_ref) {
  var isLight = _ref.isLight,
    duration = _ref.duration;
  return _react["default"].createElement(_MediaPlaybackController.StyledTimeLabel, {
    isLight: isLight
  }, formatTime(duration));
});
var MediaPlaybackControls = exports.MediaPlaybackControls = function MediaPlaybackControls(_ref2) {
  var _videoJsNode$isDispos;
  var onSeek = _ref2.onSeek,
    onTogglePlay = _ref2.onTogglePlay,
    settings = _ref2.settings,
    type = _ref2.type,
    isLight = _ref2.isLight,
    readOnly = _ref2.readOnly;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    duration = _useState4[0],
    setDuration = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    seek = _useState6[0],
    setSeek = _useState6[1];
  var isVideoJsPlayer = (0, _feature.shouldHaveFeature)('studio.videoJsPlayer');
  var _useCommonPageActions = (0, _metrics.useCommonPageActionsApi)(),
    mediaPlaybackChanged = _useCommonPageActions.mediaPlaybackChanged;
  var _useState7 = (0, _react.useState)({}),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    node = _useState8[0],
    setNode = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    videoJsNode = _useState10[0],
    setVideoJsNode = _useState10[1];
  var _id = settings._id,
    title = settings.title;
  var startStopIcon;
  if (!isVideoJsPlayer) {
    startStopIcon = node.paused ? _freeSolidSvgIcons.faPlay : _freeSolidSvgIcons.faPause;
  } else if (videoJsNode && !((_videoJsNode$isDispos = videoJsNode.isDisposed) !== null && _videoJsNode$isDispos !== void 0 && _videoJsNode$isDispos.call(videoJsNode))) {
    var _videoJsNode$paused;
    startStopIcon = (_videoJsNode$paused = videoJsNode.paused) !== null && _videoJsNode$paused !== void 0 && _videoJsNode$paused.call(videoJsNode) ? _freeSolidSvgIcons.faPlay : _freeSolidSvgIcons.faPause;
  }
  (0, _react.useEffect)(function () {
    var node = document.getElementById("media_player_".concat(_id));
    if (!isVideoJsPlayer) {
      setNode(node);
      setDuration(node.duration || 0);
      var timeUpdateHandler = function timeUpdateHandler() {
        setSeek(node.currentTime);
      };
      var durationChangeHandler = function durationChangeHandler() {
        setDuration(node.duration);
      };
      var canPlayHandler = function canPlayHandler() {
        setDuration(node.duration);
      };
      var onEndedHandler = function onEndedHandler() {
        //Ensure the video remains at the end/last frame when it ends
        node.currentTime = node.duration;
      };
      node.addEventListener('durationchange', durationChangeHandler);
      node.addEventListener('timeupdate', timeUpdateHandler);
      node.addEventListener('canplay', canPlayHandler);
      node.addEventListener('ended', onEndedHandler);
      return function () {
        node.removeEventListener('durationchange', durationChangeHandler);
        node.removeEventListener('timeupdate', timeUpdateHandler);
        node.removeEventListener('canplay', canPlayHandler);
        node.removeEventListener('ended', onEndedHandler);
      };
    } else {
      var player = (0, _video["default"])("media_player_".concat(_id));
      setVideoJsNode(player);
      player.ready(function () {
        player.on('canplay', function () {
          // Check if the video is already playing before calling play again
          if (player.paused() && settings.value.isPlaying) {
            player.play();
          }
        });
        player.on('loadedmetadata', function () {
          setDuration(player.duration() | 0);
        });
        player.on('durationchange', function () {
          setDuration(player.duration() | 0);
        });
        player.on('timeupdate', function () {
          setSeek(player.currentTime());
          setDuration(player.duration() | 0);
        });
      });
      return function () {
        player.off('loadedmetadata');
        player.off('durationchange');
        player.off('timeupdate');
        player.off('canplay');
      };
    }
  }, [_id, setSeek, setDuration, settings.value.isPlaying]);
  var handleSeek = function handleSeek(seek) {
    if (!isVideoJsPlayer) {
      setValue(null);
      node.currentTime = seek;
    } else {
      setSeek(seek);
      videoJsNode.currentTime(seek);
    }
    onSeek(_id, seek);
    mediaPlaybackChanged({
      mediaAction: _constants.MediaPlayerActions.SEEK_TO_TIME,
      seekedToTime: seek
    });
  };
  var handleChange = function handleChange(seek) {
    setValue(seek);
  };
  var handleTogglePlay = function handleTogglePlay() {
    if (!isVideoJsPlayer) {
      var _seek = node.currentTime === node.duration ? 0 : node.currentTime;
      onTogglePlay(_id, node.paused ? 'play' : 'pause', _seek);
    } else {
      var currentTime = videoJsNode === null || videoJsNode === void 0 ? void 0 : videoJsNode.currentTime();
      var _duration = videoJsNode === null || videoJsNode === void 0 ? void 0 : videoJsNode.duration();
      var isVideoPaused = videoJsNode === null || videoJsNode === void 0 ? void 0 : videoJsNode.paused();
      var _seek2 = currentTime === _duration ? 0 : currentTime;
      onTogglePlay(_id, isVideoPaused ? 'play' : 'pause', _seek2);
      mediaPlaybackChanged({
        mediaAction: isVideoPaused ? _constants.MediaPlayerActions.PLAY : _constants.MediaPlayerActions.PAUSE
      });
    }
  };
  var handleSeekToStart = (0, _react.useCallback)(function () {
    if (!isVideoJsPlayer) {
      onSeek(_id, 0);
    } else {
      onSeek(_id, 0);
      videoJsNode.currentTime(0);
      videoJsNode.play();
    }
    mediaPlaybackChanged({
      mediaAction: _constants.MediaPlayerActions.SEEK_TO_START
    });
  }, [isVideoJsPlayer, onSeek, _id, videoJsNode]);
  var getElapsed = function getElapsed() {
    if (!isVideoJsPlayer) {
      return value || seek;
    } else {
      return seek;
    }
  };
  var durationLabelProps = (0, _react.useMemo)(function () {
    return {
      isLight: isLight,
      duration: duration
    };
  }, [isLight, duration]);
  return _react["default"].createElement(_react["default"].Fragment, null, !readOnly && _react["default"].createElement(_MediaPlaybackController.StyledControlIcon, {
    icon: startStopIcon,
    "data-testid": "".concat(type, "-playing-toggle"),
    onClick: handleTogglePlay,
    isLight: isLight,
    role: "button",
    "data-dd-action-name": "".concat(node.paused ? 'Play' : 'Pause', " ").concat(title, " - ").concat(formatTime(duration - getElapsed()), "/").concat(formatTime(duration))
  }), !readOnly && _react["default"].createElement(RestartControlIcon, {
    icon: _freeSolidSvgIcons.faStepBackward,
    "data-testid": "".concat(type, "-seek-to-start"),
    onClick: handleSeekToStart,
    isLight: isLight,
    role: "button",
    "data-dd-action-name": "Restart ".concat(title)
  }), _react["default"].createElement(_MediaPlaybackController.LeftTimeWrapper, {
    readOnly: readOnly
  }, _react["default"].createElement(_MediaPlaybackController.StyledTimeLabel, {
    isLight: isLight
  }, formatTime(getElapsed()))), _react["default"].createElement(_SliderV["default"], {
    seek: seek,
    duration: duration,
    readOnly: readOnly,
    onSeek: handleSeek,
    onChange: isVideoJsPlayer ? function () {} : handleChange,
    isLight: isLight
  }), _react["default"].createElement(_MediaPlaybackController.RightTimeWrapper, {
    isLight: isLight,
    readOnly: readOnly
  }, _react["default"].createElement(_MediaPlaybackController.StyledTimeLabel, {
    isLight: isLight
  }, formatTime(duration - getElapsed())), "/", _react["default"].createElement(DurationLabel, durationLabelProps)));
};